var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',[_vm._v(" © Copyright "+_vm._s(_vm.currentYear)+" BMW Group | BMW International Feedback Management Tool | Version "+_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }